/* istanbul ignore file */

/**
 * Should have all locale keys used in this project with translations matching the language-region
 * code of this file.
 */
export default {
  done: 'Done',
  selectall: 'Select All',
  clear: 'Clear',
  category: 'Category',
  badgeSeperator: ', ',
  selected: 'Selected',
  filter: 'Filter',
  noResultsFound: 'No results found',
  groupLabel: 'Group',
  dropdown: 'Dropdown'
};
